module.exports = __webpack_public_path__ + "static/logo-abed-2e0967c3ca143f96a9a5b52b6534f488.png";